import isString from 'lodash/isString';


/**
 *
 * @param {String} token OpenTok not-JWT token
 * @return {Number} Time remaining to expiration in milliseconds
 */
export function tokenExpiresIn(token) {
  const data = parseToken(token);

  return data ? data.expire_time * 1000 - Date.now() : -1;
}

/**
 *
 * @param {String} token OpenTok not-JWT token
 * @return {Object} Token properties
 */
export function parseToken(token) {
  if (!isString(token) || token.length < 5) {
    return null;
  }

  return atob(token.substring(4))
    .split('&')
    .reduce((acc, item) => {
      const data = item.split('=');
      acc[data[0]] = data[1];
      return acc;
    }, {});
}



// WEBPACK FOOTER //
// ./src/js/comments/services/OpenTokUtils.js